import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=633ee68a&scoped=true"
import script from "./OrderList.vue?vue&type=script&lang=ts"
export * from "./OrderList.vue?vue&type=script&lang=ts"
import style0 from "./OrderList.vue?vue&type=style&index=0&id=633ee68a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633ee68a",
  null
  
)

export default component.exports